import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-page-hero',
    templateUrl: './page-hero.component.html',
    styleUrls: ['./page-hero.component.css'],
    host: {class: 'block'},
})
export class PageHeroComponent {
    @Input({required: true}) heading!: string;
    @Input({required: true}) subheading!: string;
    @Input({required: true}) image!: string;
}
